import { render, staticRenderFns } from "./commentDialog.vue?vue&type=template&id=243140a8&scoped=true&lang=pug"
import script from "./commentDialog.vue?vue&type=script&lang=js"
export * from "./commentDialog.vue?vue&type=script&lang=js"
import style0 from "./commentDialog.vue?vue&type=style&index=0&id=243140a8&prod&lang=scss&scoped=true"
import style1 from "./commentDialog.vue?vue&type=style&index=1&id=243140a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243140a8",
  null
  
)

export default component.exports